export default "/_next/static/chunks/fonts/MaterialIcons-5e7382c63da0098d634a356ff441614e.ttf";